import Shell from './Shell/Shell';
import Frame from './Frame/Frame';
import Pane from './Pane/Pane';

const TileKit = {
  Shell,
  Frame,
  Pane
};

export default TileKit;
